import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

const initialState = {
	zpInstance: '',
	zimUserDetails: {},
};

const zegoCloudStore = (set: any) => ({
	...initialState,
	setZpInstance: (data: string) => set((state: any) => ({ ...state, zpInstance: data })), // Adjusted type
	setZimUserDetails: (data: object) => set((state: any) => ({ ...state, zimUserDetails: data })), // Adjusted type
	resetState: () => set({ ...initialState }), // Reset function
});

const useZegoCloudStore = create(devtools(zegoCloudStore));

export const { setZpInstance, setZimUserDetails, resetState } = useZegoCloudStore.getState();

export default useZegoCloudStore;
